import script from "./MakeupApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeupApproval.vue?vue&type=script&setup=true&lang=js"

import "./MakeupApproval.vue?vue&type=style&index=0&id=05ded8fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ded8fe"]])

export default __exports__